export const LOCAL_STORAGE_KEY = 'karma_auth';
export const BREAKPOINTS = {
  SM: 768,
  XS: 375,
};
export const TENOR_API_KEY = 'AIzaSyDiNPC0wIELU7wzUGdMWvT8WuIJuTyZxfY';
export const TENOR_CLIENT_KEY = 'karma_web';
export const TENOR_BASE_URL = 'https://tenor.googleapis.com/v2';

export const LANGUAGES = ['en', 'es', 'pt', 'ru', 'ua'];
